import type { Messages } from "@prop/i18n";
import type en from "../en/config";

export default {
  label: "Соберите свой челлендж",
  loading: "Загружаем каталог…",
  empty: "Для такого сочетания программы пока нет.",
  product: {
    label: "Продукт",
    markets: "FX и CFD",
    futures: "Фьючерсы",
    perps: "Крипто 24/7",
  },
  productNote: {
    markets: "Валюты, металлы и индексы",
    futures: "CME, NYMEX и COMEX",
    perps: "Работает 24/7, и в выходные",
  },
  instruments: "Инструментов: {n}",
  evaluation: {
    label: "Оценка",
    instant: "Instant",
    "1step": "1 этап",
    "2step": "2 этапа",
    sprint: "Спринт",
  },
  size: {
    label: "Размер счёта",
    recommended: "Советуем",
    cards: "Карточки",
    table: "Таблица",
    view: "Вид",
  },
  type: { label: "Тип челленджа" },
  tag: {
    noDaily: "Без дневной просадки",
    lowestTarget: "Самая низкая цель",
    noConsistency: "Без правила консистентности",
    cheapest: "Самый доступный",
    widest: "Самая широкая просадка",
    fullSplit: "Доля до 100 %",
    turbo: "Есть Turbo",
    window: "Одна сессия на {h} ч",
  },
  model: {
    label: "Модель челленджа",
    classic: "Classic",
    turbo: "Turbo",
    futClassic: "Без activation fee",
    futTurbo: "Standard",
    classicNote: "Платите один раз, при funded ничего",
    plusFee: "+ {fee} при переходе в funded",
  },
  rules: {
    all: "Все условия",
    allHide: "Свернуть условия",
    extra: "Ещё правила",
    title: "Правила счёта",
    split: "Ваша доля",
    target: "Цель по прибыли",
    daily: "Дневная просадка",
    max: "Макс. просадка",
    reward: "Бонус за результат",
    rewardNote: "один раз, после роста на {g} % в funded",
    tradeLoss: "Убыток одной сделки",
    tradeLossNote: "funded-счёт, и по открытой сделке",
    none: "Нет",
    less: "Меньше: {k}",
    more: "Больше: {k}",
  },
  reward: {
    scaling: "Масштабирование",
    scalingCell: "+{step} % каждые {months} мес.",
    scalingNote: "до {max} на том же счёте",
    title: "Выплаты",
    cycle: "Цикл выплат",
    cycles: { on_demand: "По запросу", weekly: "Раз в неделю", bi_weekly: "Раз в 2 недели", monthly: "Раз в месяц" },
    consistency: "Консистентность",
    bestDay: "Лучший день ≤ {v} %",
    evalConsistency: "оценка: лучший день ≤ {v} %",
    days: "Мин. торговых дней",
    daysNote: "дни с прибылью ≥ {v}",
    rewardsIn: "Первая выплата через",
    rewardsInDays: "{n} дн.",
    onDemand: "По запросу",
    feeRefund: "Возврат платы",
    feeRefundCell: "{pct} % с выплатой №{n}",
    cap: "Лимит первой выплаты",
    minTrades: "Мин. закрытых сделок",
    bestTrade: "Лучшая сделка",
    bestTradeCell: "≤ {v} % прибыли",
    payouts: "Выплат на счёт",
    once: "Одна",
  },
  details: {
    title: "Детали счёта",
    time: "Срок",
    unlimited: "Без срока",
    days: "{n} дн.",
    window: "{h} ч с первой сделки",
    tradingDays: "Макс. торговых дней",
    leverage: "Плечо",
    instruments: "Инструменты",
    drawdownType: "Тип просадки",
    dayEnds: "Торговый день заканчивается",
    contracts: "Макс. контрактов",
    contractsCell: "{n} на инструмент",
    flat: "Позиции закрываются",
    flatCell: "ежедневно в {time} ({city})",
    news: "Торговля на новостях",
    weekend: "Позиции на выходные",
    allowed: "Можно",
    newsCell: "Без новых сделок ±{n} мин (funded-счёт)",
    weekendCell: "Закрываются в пт 16:55 Нью-Йорк (funded-счёт)",
    coach: "ИИ-коуч",
    included: "Входит",
    activation: "Activation fee",
    activationCell: "{fee} при переходе в funded",
  },
  summary: {
    pick: "Выберите бонус",
    offNote: "уже в цене",
    save: "Экономия {v}",
    currency: "USD",
    offer: "Предложение ограничено",
    off: "−{v} %",
    buyGet: "1 + {n} СЧЁТА",
    resets: "{n} БЕСПЛАТНЫЙ СБРОС",
    start: "Начать челлендж",
    fullRules: "Все правила",
    payWith: "Оплата криптовалютой: стейблкоины (USDT, USDC) или основные монеты. Аккаунт откроется, как только платёж подтвердится.",
    oneTime: "разовая плата",
    whenFunded: "+ {fee} при переходе в funded",
    more: "Что это значит",
  },
  tips: {
    buyGetShort: "+{n} счёта, открываются с выплатами",
    resetShort: "Бесплатный перезапуск, если оценка не пройдена",
    off: "Сегодня цена на {v} % ниже списочной. Скидка уже учтена — код вводить не нужно.",
    buyGet: "К этому счёту прилагаются ещё {n} — тот же план, размер и опции. Они открываются по очереди: первый — с вашей первой оплаченной выплатой, следующий — со следующей.",
    reset: "Если оценка не задалась, мы бесплатно запустим счёт заново со стартового баланса — тот же план, ничего покупать не нужно.",
  },
  table: {
    size: "Размер",
    price: "Цена",
    target: "Цель",
    daily: "Дневная",
    max: "Макс.",
    split: "Доля",
    fee: "При funded",
    pick: "Выбрать {size}",
  },
  buy: {
    config: "Конфигурация",
    split: "Ваша доля",
    model: "Модель",
    activation: "Activation fee",
    activationNote: "списывается при переходе счёта в funded",
    list: "Цена по прайсу",
    offers: "В комплекте",
  },
  offers: {
    title: "Предложения этой покупки",
    lead: "Что пришло вместе с покупкой и когда откроется.",
    extra: "Дополнительный счёт №{n}",
    locked: "Откроется с оплаченной выплатой №{n}",
    opened: "Открыт",
    open: "Открыть",
    void: "Аннулирован",
    reset: "Бесплатный сброс",
    resetReady: "Оценка закончилась. Запустите её заново со стартового баланса на тех же правилах — бесплатно.",
    resetUse: "Использовать сброс",
    resetDone: "Перезапущено. Открываем новый счёт…",
    resetHint: {
      not_failed: "Станет доступен, если эта оценка не будет пройдена",
      not_evaluation: "На funded-счёте сброса нет",
      no_free_reset: "Уже использован",
      no_offer: "У этого счёта нет сброса",
      already_restarted: "Этот счёт уже перезапускали",
    },
    activation: "Activation fee",
    activationDue: "{fee} к оплате при переходе в funded",
    paidReset: "Сброс после нарушения",
    paidResetReady: "Перезапустить счёт со стартового баланса, на тех же правилах и размере, за {fee}.",
    paidResetUse: "Купить сброс · {fee}",
    paidResetHint: { not_failed: "Доступен после нарушения", already_restarted: "Этот счёт уже перезапущен" },
    haircut: "Штраф за сброс",
    haircutText: "Счёт сброшен после нарушения правил: каждая выплата по нему меньше на {pct} %, навсегда.",
    config: "Конфигурация",
    split: "Доля {v} %",
  },
  scaling: {
    title: "План масштабирования",
    lead: "Каждые {months} мес.: +{step} % к размеру счёта, до {max}. Тот же счёт, те же условия.",
    period: "Прошло {months} мес.",
    periodCell: "до {at}",
    growth: "Рост ≥ {pct} %",
    growthCell: "{v} из {need}",
    payouts: "Оплаченные выплаты",
    payoutsCell: "{n} из {need}",
    profit: "Счёт в прибыли",
    next: "Следующий размер",
    up: "Увеличить до {size}",
    max: "Счёт уже максимального размера.",
    history: "Увеличен {from} → {to}",
  },
} satisfies Messages<typeof en>;
